module.exports = __webpack_public_path__ + "static/media/routeMap.39a4354a.png";